import React, { useEffect, useRef, useState } from "react";
import { FormLabel, FormControl as Input } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { BsInfoCircle } from "react-icons/bs";
import DefaultButton from "components/DefaultButton";
import { Tooltip } from "@mui/material";
import { maskNumber } from "Auxiliar/Masks";

const FormCard = props => {

    const {
        onChange,
        initialCards
    } = props;

    const [number, SetNumber] = useState("");
    const [text, SetText] = useState("");
    const [cardList, SetCardList] = useState([...initialCards]);

    const firstInputRef = useRef(null);

    const HandleCardAdd = () => {
        if (!number && !text) {
            firstInputRef.current.focus();
            return;
        }

        let tempCardList = cardList;
        let cardData = {
            number: number,
            text: text
        };
        tempCardList.push(cardData);

        SetCardList([...tempCardList]);
        SetNumber("");
        SetText("");
        onChange(tempCardList);
    }

    const HandleCardRemove = index => {
        let tempCardList = cardList;

        tempCardList.splice(index, 1);
        SetCardList([...tempCardList]);
        onChange(tempCardList);
    }

    useEffect(() => SetCardList(initialCards), [initialCards]);

    return (
        <div className="card-add-form">
            <FormLabel>
                Número 
            </FormLabel>
            <Input
                placeholder="Número"
                value={number}
                onChange={e => SetNumber(maskNumber(e.target.value))}
                ref={firstInputRef}
            />
            <br/>
            <FormLabel>Texto</FormLabel>
            <Input
                placeholder="Texto do card"
                value={text}
                onChange={e => SetText(e.target.value)}
                as="textarea"
            />
            <br/>
            
            <DefaultButton
                text="Adicionar card"
                style={{
                    width: "fit-content"
                }}
                onClick={HandleCardAdd}
            />
            
            <div className="table-responsive" hidden={cardList.length == 0}>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Número</th>
                            <th>Texto</th>
                            <th>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cardList.map((value, index) => (
                            <tr key={index}>
                                <td className="text-truncate" style={{maxWidth: "150px"}}>{value.number}</td>
                                <td className="text-truncate" style={{maxWidth: "150px"}}>{value.text}</td>
                                <td>
                                    <DefaultButton
                                        onClick={() => HandleCardRemove(index)}
                                        width="2.2em"
                                        height="2.2em"
                                        padding={0}
                                        number={`Remover card`}
                                        bg="danger"
                                        icon={<MdDelete size={17} color="white"/>}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default FormCard;